import { SearchXIcon } from 'lucide-react';

interface PullListNoResultsProps {
  searchTerm: string;
  hasFilters: boolean;
}

export function PullListNoResults({ searchTerm, hasFilters }: PullListNoResultsProps) {
  const getMessage = () => {
    if (searchTerm && hasFilters) {
      return 'No pull requests match your search term and filters.';
    } else if (searchTerm) {
      return 'No pull requests match your search term.';
    } else if (hasFilters) {
      return 'No pull requests match your current filters.';
    } else {
      return 'No pull requests found in this organization.';
    }
  };

  return (
    <div className="h-full flex flex-col items-center justify-center px-8 py-12">
      <div className="flex flex-col items-center gap-4 max-w-md text-center">
        <div className="rounded-full bg-muted p-3">
          <SearchXIcon className="h-8 w-8 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-medium">No pull requests found</h3>
          <p className="text-sm text-muted-foreground">{getMessage()}</p>
        </div>
      </div>
    </div>
  );
}
